import React, { ChangeEvent, useEffect, useState } from "react";
import { Box, FormHelperText } from "@mui/material";
import TkLabelText from "../../../atoms/TkLabelText";
import { ITkPostCodeTextProps } from "../../../../type/componentsType/TkSuperPowerText";
import "../_style.scss";

/**
 * 特殊テキストボックス部品
 * 郵便番号を入力するためのグループフォーム
 * @param postCode - 郵便番号
 * @param onChange - 入力値が変更されたときに呼び出される関数
 * @return TkPostCode 特殊テキストボックス部品
 */
export const TkPostCode: React.FC<ITkPostCodeTextProps> = (props) => {
  const {
    size = "small",
    onChange,
    disabled = false,
    wantToSetValue = "",
    onGetInputValue,
    error,
    helperText,
    ...rest
  } = props;
  const [firstThreeDigits, setFirstThreeDigits] = useState("");
  const [lastFourDigits, setlastFourDigits] = useState("");

  useEffect(() => {
    setFirstThreeDigits(wantToSetValue?.slice(0, 3) || "");
    setlastFourDigits(wantToSetValue?.slice(3) || "");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [wantToSetValue]);

  /**
   * 電話番号の桁数が変更されたときに呼ばれる関数
   * @param event - 変更イベントオブジェクト
   * @param digits - 変更された桁数
   */
  const handleDigitsChange = (
    event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
    digits: "firstThree" | "lastFour"
  ) => {
    const newValue = event.target.value;

    let newPostCode = "";
    let postCodeForCheck = "";

    switch (digits) {
      case "firstThree":
        setFirstThreeDigits(newValue);
        newPostCode = `${newValue}-${lastFourDigits}`;
        postCodeForCheck = `${newValue}${lastFourDigits}`;
        break;
      case "lastFour":
        setlastFourDigits(newValue);
        newPostCode = `${firstThreeDigits}-${newValue}`;
        postCodeForCheck = `${firstThreeDigits}${newValue}`;
        break;
    }

    onChange?.({
      target: { value: postCodeForCheck, valueForShow: newPostCode },
    });

    onGetInputValue?.({
      firstThreeDigits,
      lastFourDigits,
      postCodeForCheck,
      postCodeForShow: newPostCode,
    });
  };

  const className = "postCodeInputLabel";
  const labelTextProps = {
    className,
    ...rest,
    onlyNumber: true,
  };

  return (
    <Box data-testid="tkPostCodeInput" className="postCodeInputArea">
      <Box className="postCodeInput">
        <TkLabelText
          data-testid="tkSuperPowerTextFirstForTest"
          value={firstThreeDigits}
          size={size}
          InputProps={{
            inputProps: { maxLength: 3, "data-testid": "postCodeFirst" },
          }}
          onChange={(e) => handleDigitsChange(e, "firstThree")}
          {...labelTextProps}
          error={error}
          disabled={disabled}
          wantToSetValue={firstThreeDigits}
        />

        <TkLabelText
          data-testid="tkSuperPowerTextLastForTest"
          value={lastFourDigits}
          InputProps={{
            inputProps: { maxLength: 4, "data-testid": "postCodeLast" },
          }}
          size={size}
          onChange={(e) => handleDigitsChange(e, "lastFour")}
          {...labelTextProps}
          error={error}
          disabled={disabled}
          wantToSetValue={lastFourDigits}
        />
      </Box>
      {error && <FormHelperText error>{helperText}</FormHelperText>}
    </Box>
  );
};
export default TkPostCode;
